import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React from 'react';
import PropTypes from 'prop-types';
import Checkbox from '../checkbox/checkbox';
import Text from '../text/text';
import { dataHooks } from './constants';
import { st, classes } from './ActionsListItem.st.css';
var ActionsListItem = /*#__PURE__*/function (_React$Component) {
  function ActionsListItem() {
    var _this;
    _classCallCheck(this, ActionsListItem);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, ActionsListItem, [].concat(args));
    _defineProperty(_this, "_handleClick", function () {
      var _this$props = _this.props,
        disabled = _this$props.disabled,
        value = _this$props.value,
        onChange = _this$props.onChange;
      if (typeof onChange !== 'function' || disabled) {
        return;
      }
      onChange(!value);
    });
    return _this;
  }
  _inherits(ActionsListItem, _React$Component);
  return _createClass(ActionsListItem, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        dataHook = _this$props2.dataHook,
        className = _this$props2.className,
        disabled = _this$props2.disabled,
        value = _this$props2.value,
        prefixIcon = _this$props2.prefixIcon,
        label = _this$props2.label,
        suffix = _this$props2.suffix,
        alwaysShowSuffix = _this$props2.alwaysShowSuffix,
        subtitle = _this$props2.subtitle;
      return /*#__PURE__*/React.createElement("div", {
        className: st(classes.root, {
          disabled: disabled
        }, className),
        "data-hook": dataHook,
        disabled: disabled,
        onClick: this._handleClick
      }, /*#__PURE__*/React.createElement("div", {
        onClick: function onClick(e) {
          e.stopPropagation();
        }
      }, /*#__PURE__*/React.createElement(Checkbox, {
        value: value,
        onChange: this._handleClick,
        disabled: disabled,
        dataHook: dataHooks.checkbox
      })), prefixIcon && /*#__PURE__*/React.createElement("div", {
        className: classes.icon
      }, prefixIcon), /*#__PURE__*/React.createElement("div", {
        className: classes.label
      }, /*#__PURE__*/React.createElement(Text, {
        dataHook: dataHooks.label,
        size: "medium",
        disabled: disabled,
        shouldTranslate: false,
        enableEllipsis: true
      }, label), subtitle && /*#__PURE__*/React.createElement(Text, {
        dataHook: dataHooks.subtitle,
        size: "small",
        weight: "thin",
        skin: "secondary",
        disabled: disabled,
        shouldTranslate: false,
        enableEllipsis: true
      }, subtitle)), suffix && /*#__PURE__*/React.createElement("div", {
        onClick: function onClick(e) {
          e.stopPropagation();
        },
        "data-hook": dataHooks.suffix,
        className: st(classes.suffix, {
          visible: alwaysShowSuffix
        })
      }, suffix));
    }
  }]);
}(React.Component);
ActionsListItem.displayName = 'ActionsListItem';
ActionsListItem.propTypes = {
  /** Applies a data-hook HTML attribute that can be used in the tests */
  dataHook: PropTypes.string,
  /** Main item text */
  label: PropTypes.string.isRequired,
  /** defines if checkbox is checked or not */
  value: PropTypes.bool,
  /** Callback function called on click event */
  onChange: PropTypes.func,
  /** Node for the main icon */
  prefixIcon: PropTypes.node,
  /** Node for suffix icon */
  suffix: PropTypes.node,
  /** Callback function called on click event */
  alwaysShowSuffix: PropTypes.bool,
  /** When set to true, can not be clicked and applies disabled styles */
  disabled: PropTypes.bool,
  /** Subtitle item text */
  subtitle: PropTypes.string
};
ActionsListItem.defaultProps = {
  value: false,
  prefixIcon: null,
  alwaysShowSuffix: false,
  disabled: false
};
export default ActionsListItem;